<template>
  <div>
    <div v-if="mode == 'DESIGN'" class="phone-con">
      <div :class="inputType=='both'?'head-text head-text-all':'head-text'">{{headText}}</div>
      <el-input size="small" class="disabled-box phone-input" :placeholder="placeholder"  maxlength="20"/>
    </div>
    <div v-else-if="!readerMode || perm==='E'" class="phone-con">
      <div v-if="inputType!='both'" :class="[perm==='R'?'head-text head-text-disabled':'head-text']" >{{headText}}</div>
      <el-input size="small"  class="phone-input" clearable v-model="_value.value" :placeholder="placeholder" @input="change"  maxlength="20"  :disabled="perm==='R'" >
        <el-select v-if="inputType=='both'" class="head-text-select"  v-model="tempType" size="small" @change="changeSelect" slot="prepend" :disabled="perm==='R'" >
          <el-option  label="手机" value="phone"></el-option>
          <el-option  label="固话" value="tel"></el-option>
        </el-select>
      </el-input>

    </div>
    <div v-else  class="form-item-text">
      <template v-if="_value.value">
        {{headTextDis}} {{ _value.value }}
      </template>
    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "PhoneInput",
  components: {},
  props: {
    value:{
      type: Object,
      default: () => {
        return {
          inputType:'',
          value:''
        }
      }
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    readerMode: {
      type: Boolean,
      default: false,
    },
    inputType: {
      type: String,
      default: 'phone'
    },
  },
  computed: {
    headText() {
      if(!this.inputType) return
      let text = {
        'phone': '手机',
        'tel': '固话',
        'both': '手机或固话',
      }
      return text[this.inputType]
    },
    headTextDis() {
      if(!this.value.inputType) return '手机'
      let text = {
        'phone': '手机',
        'tel': '固话',
      }
      return text[this.value.inputType]
    },
    _value: {
      get: function () {
        this.tempType =  this.value.inputType?this.value.inputType :(this.inputType=='both'?'phone':this.inputType)
        // this.value.value = ''
        return this.value;
      },
      set: function (e) {
        // console.log('set2',e)
        this.$emit("change", e);
      },
    },
  },
  data() {
    return {
      phoneType:'phone',
      tempType:''
    }
  },
  methods: {
    changeSelect(e){
      if(this.value.value){
        this.value.inputType = this.tempType
        this.$emit("change", this.value);
      }
    },
    change(e){
      if(e==''){
        // console.log('del',)
        this.$emit("delInput");
      }else{
        this.value.inputType = this.tempType
        this.$emit("change", this.value);
      }
      
      
    }
  },

}
</script>

<style scoped lang="scss">
.phone-con{
  display: flex;
  line-height: 1;
  max-width: 320px;
  .head-text{
    border: 1px solid #E3E6E5;
    border-right: none;
    background-color: #FFF;
    height: 32px;
    box-sizing: border-box;
    width: 46px;
    border-radius: 4px 0 0 4px;
    flex-shrink: 0;
    padding-left: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
    color: #2F3030;
  }
  .head-text-all{
    width: 88px;
  }
  .head-text-disabled{
    cursor: no-drop;
    background: #F5F7FA;
    color: #C0C4CC;
  }
  /deep/.phone-input .el-input__inner{
    border-radius: 0 4px 4px 0;
  }
  /deep/.el-input-group__prepend{
    background-color: #fff;
    .el-input__inner{
      border: none;
      font-size: 14px;
      color: #2F3030;
      font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
    }
  }
  /deep/.is-disabled .el-input-group__prepend{
    background-color: #F5F7FA;
    .el-input__inner{
      color: #C0C4CC;
    }
  }
  .head-text-select{
    width: 68px!important;
    &:hover /deep/.el-input__inner{
      color: #2F3030;
    }
    
  }
}
.process-form-show .phone-con{
  margin-top: 6px;
}
</style>
